module.exports = __webpack_public_path__ + "static/media/removeBtn.4382c92f.svg";